import { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { useDispatch } from "react-redux";
import "./App.css";
import { AppRouter } from "./components/app/AppRouter";
import Popups from "./components/DesignSystem/Popups/Popups";
import Toasters from "./components/DesignSystem/Toasters/Toasters";
import { loadMessages } from "./l10n/loader";
import { doneLoadingStrings } from "./store/context";

function App() {
	const [localeMessages, setLocaleMessages] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		(async function () {
			const messages = await loadMessages("en-us");
			setLocaleMessages(messages);
			doneLoadingStrings();
		})();
	}, [doneLoadingStrings]);

	return (
		<IntlProvider locale={"en-us"} messages={localeMessages}>
			<div className="App">
				<AppRouter />
				<Toasters />
				<Popups />
			</div>
		</IntlProvider>
	);
}

export default App;
